import { c as _c } from "react/compiler-runtime";
import type { FC, SVGProps } from "react";

// Source: https://fonts.google.com/icons?icon.query=stop&selected=Material+Symbols+Rounded:stop:FILL@1;wght@300;GRAD@0;opsz@24&icon.size=24&icon.color=%23e3e3e3&icon.style=Rounded
export const StopIcon: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <title>Stop Icon</title>;
    t1 = <path d="M6.5 15.6923V8.30775C6.5 7.81058 6.677 7.385 7.031 7.031C7.385 6.677 7.81058 6.5 8.30775 6.5H15.6923C16.1894 6.5 16.615 6.677 16.969 7.031C17.323 7.385 17.5 7.81058 17.5 8.30775V15.6923C17.5 16.1894 17.323 16.615 16.969 16.969C16.615 17.323 16.1894 17.5 15.6923 17.5H8.30775C7.81058 17.5 7.385 17.323 7.031 16.969C6.677 16.615 6.5 16.1894 6.5 15.6923Z" fill="currentColor" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};